import { FormControl, Grid, Typography } from '@mui/material';
import {
  BaseFieldProps,
  withGridItemCSS,
  withWrapperCSS,
} from 'components/organisms/forms/form-builder/types';
import React, { FC } from 'react';

export const TextDivider: FC<BaseFieldProps & withGridItemCSS & withWrapperCSS> = ({
  error = false,
  gridItemCss,
  label = '',
  required = false,
  wrapperCss,
  xs = 12,
}) => {
  return (
    <Grid item xs={xs} style={gridItemCss}>
      <FormControl
        error={!!error}
        required={required}
        style={{ width: '100%', ...wrapperCss }}
      >
        <Typography variant={'h5'}>{label}</Typography>
      </FormControl>
    </Grid>
  );
};
